import { library } from '@fortawesome/fontawesome-svg-core';
import * as faIcons from './font-awesome-icons';

export function initAllIcons(): void {
	library.add(...Object.values(faIcons));
}
